// extracted by mini-css-extract-plugin
export default {"Wrapper":"Spinner_Wrapper__ZqG8k","Content":"Spinner_Content__oP7HZ","spinner-content-animation":"Spinner_spinner-content-animation__rlrzJ"};